
require("clover/utils/GameSpeedManager")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")

var GameGuideDoubleSpeedPanel = xClass("GameGuideDoubleSpeedPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/double_guidance_panel_prompt.csb")
})

GameGuideDoubleSpeedPanel.show = function (callback) {
    function success() {
        let panel = GameGuideDoubleSpeedPanel.create()
        panel.popup(true)
        panel.callback = callback
    }
    preloadWithLoading(["packed/GameGuideDoubleSpeedPanelRes.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}
GameGuideDoubleSpeedPanel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)

    var okBtn = self.getChild("btn")
    btn = UIGroupButton.create(okBtn)
    ButtonPushBounceAnim.create(btn)
    btn.on(UIButtonEvent.Click, function () {
        self.onOkTapped()
    })
}
GameGuideDoubleSpeedPanel.prototype.popup = function () {
    var self = this
    // body
    var targetScale = self.getScale()
    self.setScale(0)
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var s = self.getContentSize()
    var pos = self.getAnchorPoint()
    var vSize = cc.Director.getInstance().getVisibleSize()
    var targetPos = cc.p((vSize.width - s.width) * 0.5 + s.width * pos.x + s.width*0.5, (vSize.height + s.height) * 0.5 + s.height * pos.y - s.height*0.5)
    self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
    var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.05)
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint))), cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))))
    return self
}
GameGuideDoubleSpeedPanel.prototype.fitResolution = function () {
    var self = this
    // body
}
GameGuideDoubleSpeedPanel.prototype.onCleanup = function () {
    ResManager.release(["packed/GameGuideDoubleSpeedPanelRes.pack"])
}
GameGuideDoubleSpeedPanel.prototype.onOkTapped = function(){
    this.callback()
    this.onClose()
}

module.exports = GameGuideDoubleSpeedPanel